import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	emptyStateTitle: {
		id: 'company-hub.article-search-component.empty-title',
		defaultMessage: 'We couldn’t find a match for your search',
		description:
			'Text displayed in the dialog when an error occurs during the article search attempt.',
	},
	emptyStateDescription: {
		id: 'company-hub.article-search-component.empty-description',
		defaultMessage: 'Check for typos, or try another search term.',
		description:
			'Text displayed in the article search dialog to guide users when there is an error.',
	},
	errorTitle: {
		id: 'company-hub.article-search-component.error-title',
		defaultMessage: 'We’re having trouble getting your results.',
		description:
			'Text displayed in the dialog when an error occurs during the article search attempt.',
	},
	errorDescription: {
		id: 'company-hub.article-search-component.error-description',
		defaultMessage: 'Try again later',
		description:
			'Text displayed in the article search dialog to guide users when there is an error.',
	},
});
